import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import Asset from '@/plugins/sdk/resources/Asset'
import Branch from '@/plugins/sdk/resources/Dictionary/BusinessBranch'
import Account from '@/plugins/sdk/resources/Account'
import Team from '@/plugins/sdk/resources/Team'
import Profile from '@/plugins/sdk/resources/Profile'
import Note from '@/plugins/sdk/resources/Note'
import Attachment from '@/plugins/sdk/resources/Asset/Event/Attachment'

export const TYPE_ALLOCATE = 'allocate'
export const TYPE_RETURN = 'return'
export const TYPE_WARRANTY = 'warranty'
export const TYPE_CREATED = 'created'
export const TYPE_TRANSFER = 'transfer'
export const TYPE_BROKEN = 'broken'

export default class extends Resource {
  static name = 'asset_event'

  static get fields () {
    return {
      id: new UUID(),
      type: new STRING(),
      asset: new ITEM(Asset),
      branch: new ITEM(Branch),
      account: new ITEM(Account),
      team: new ITEM(Team),
      profile: new ITEM(Profile),
      created_by_profile: new ITEM(Profile),
      notes: new COLLECTION(Note),
      attachments: new COLLECTION(Attachment),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
